/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompletedIntervalDTO } from './CompletedIntervalDTO';
import {
    CompletedIntervalDTOFromJSON,
    CompletedIntervalDTOFromJSONTyped,
    CompletedIntervalDTOToJSON,
    CompletedIntervalDTOToJSONTyped,
} from './CompletedIntervalDTO';

/**
 * 
 * @export
 * @interface CompletionData
 */
export interface CompletionData {
    /**
     * 
     * @type {Array<CompletedIntervalDTO>}
     * @memberof CompletionData
     */
    completedIntervals?: Array<CompletedIntervalDTO>;
    /**
     * 
     * @type {string}
     * @memberof CompletionData
     */
    executionType: CompletionDataExecutionTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CompletionData
     */
    trackPerSide?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompletionData
     */
    completedPrimaryValue?: number;
    /**
     * 
     * @type {number}
     * @memberof CompletionData
     */
    completedSecondaryValue?: number;
    /**
     * 
     * @type {number}
     * @memberof CompletionData
     */
    completedPrimaryWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof CompletionData
     */
    completedSecondaryWeight?: number;
    /**
     * 
     * @type {string}
     * @memberof CompletionData
     */
    startedTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof CompletionData
     */
    completedTimestamp?: string;
}


/**
 * @export
 */
export const CompletionDataExecutionTypeEnum = {
    Reps: 'reps',
    Duration: 'duration',
    Intervals: 'intervals'
} as const;
export type CompletionDataExecutionTypeEnum = typeof CompletionDataExecutionTypeEnum[keyof typeof CompletionDataExecutionTypeEnum];


/**
 * Check if a given object implements the CompletionData interface.
 */
export function instanceOfCompletionData(value: object): value is CompletionData {
    if (!('executionType' in value) || value['executionType'] === undefined) return false;
    return true;
}

export function CompletionDataFromJSON(json: any): CompletionData {
    return CompletionDataFromJSONTyped(json, false);
}

export function CompletionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletionData {
    if (json == null) {
        return json;
    }
    return {
        
        'completedIntervals': json['completedIntervals'] == null ? undefined : ((json['completedIntervals'] as Array<any>).map(CompletedIntervalDTOFromJSON)),
        'executionType': json['executionType'],
        'trackPerSide': json['trackPerSide'] == null ? undefined : json['trackPerSide'],
        'completedPrimaryValue': json['completedPrimaryValue'] == null ? undefined : json['completedPrimaryValue'],
        'completedSecondaryValue': json['completedSecondaryValue'] == null ? undefined : json['completedSecondaryValue'],
        'completedPrimaryWeight': json['completedPrimaryWeight'] == null ? undefined : json['completedPrimaryWeight'],
        'completedSecondaryWeight': json['completedSecondaryWeight'] == null ? undefined : json['completedSecondaryWeight'],
        'startedTimestamp': json['startedTimestamp'] == null ? undefined : json['startedTimestamp'],
        'completedTimestamp': json['completedTimestamp'] == null ? undefined : json['completedTimestamp'],
    };
}

export function CompletionDataToJSON(json: any): CompletionData {
    return CompletionDataToJSONTyped(json, false);
}

export function CompletionDataToJSONTyped(value?: CompletionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'completedIntervals': value['completedIntervals'] == null ? undefined : ((value['completedIntervals'] as Array<any>).map(CompletedIntervalDTOToJSON)),
        'executionType': value['executionType'],
        'trackPerSide': value['trackPerSide'],
        'completedPrimaryValue': value['completedPrimaryValue'],
        'completedSecondaryValue': value['completedSecondaryValue'],
        'completedPrimaryWeight': value['completedPrimaryWeight'],
        'completedSecondaryWeight': value['completedSecondaryWeight'],
        'startedTimestamp': value['startedTimestamp'],
        'completedTimestamp': value['completedTimestamp'],
    };
}

